import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  setCoinsUsedInEditingBooking,
  setIsEditingBooking,
  setEditBookingToken,
  setDingusCustomerCodeUsedInEditingBooking,
} from '../../../actions/Booking';
import './EditModeExit.css';

const EditModeExit = (props, context) => {
  const navigate = useNavigate();

  const onExit = () => {
    props.dispatch(setCoinsUsedInEditingBooking(0));
    props.dispatch(setIsEditingBooking(false));
    props.dispatch(setEditBookingToken(null));
    props.dispatch(setDingusCustomerCodeUsedInEditingBooking(null));
    navigate('/thanks/');
  };
  return (
        <div className="edit-mode-exit-container">
        <span className="edit-mode-message">{context.t('You are editing your reservation')}</span>
        <button
            className="exit-edit-button"
            onClick={() => onExit()}
        >
            {context.t('Exit edit mode')}
        </button>
        </div>
  );
};

EditModeExit.propTypes = {
  name: PropTypes.string.isRequired,
  bookingStatus: PropTypes.string.isRequired,
};

EditModeExit.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  multipleRoomSelection: state.booking.multipleRoomSelection,
  cart: state.cart,
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
}))(EditModeExit);
